import React from 'react'

import { PhotoThumbnail } from '@components/common/PhotoThumbnail'
import { QuantityBadge } from '@components/common/QuantityBadge'

import * as S from './styled'
import type { CollectionTableCellProps } from './types'

export const CollectionTableCell = ({ name, quantity, photoUrl }: CollectionTableCellProps) => {
  return (
    <S.Container>
      <S.Photo>
        <PhotoThumbnail url={photoUrl} size="large" />
        {quantity > 0 && <QuantityBadge quantity={quantity} />}
      </S.Photo>
      <S.Name>{name}</S.Name>
    </S.Container>
  )
}
